(function () {
  function isRunningPage() {
    return window.location.pathname.startsWith('/running');
  }

  function isAllowedProduct(url) {
    if (!url) return false;
    const u = url.toLowerCase();
    return u.includes('/products/') && (u.includes('run') || u.includes('running'));
  }

  function filterPredictiveDrawer() {
    if (!isRunningPage()) return;

    const resultsRoot = document.querySelector('#search-drawer .predictive-search__results');
    if (!resultsRoot) return;

    const productLinks = resultsRoot.querySelectorAll('a[href*="/products/"]');

    productLinks.forEach(link => {
      const href = link.getAttribute('href');

      if (!isAllowedProduct(href)) {
        const row = link.closest(
          'li, .predictive-search__item, .predictive-search__result, .predictive-search__result-item, div'
        );
        if (row) row.remove();
      }
    });
  }

  function attachObserver() {
    const resultsRoot = document.querySelector('#search-drawer .predictive-search__results');
    if (!resultsRoot) return false;

    const observer = new MutationObserver(filterPredictiveDrawer);
    observer.observe(resultsRoot, { childList: true, subtree: true });

    filterPredictiveDrawer();
    return true;
  }

  let tries = 0;
  const interval = setInterval(() => {
    tries++;
    if (attachObserver() || tries > 30) {
      clearInterval(interval);
    }
  }, 200);
})();
